enum TASK_STATUS {
  COMPLETED = 'C',
  PENDING = 'P'
}

export default TASK_STATUS;